import { StateAcronym } from "./state-acronym";

export class City {
  private stateAcronym: StateAcronym;
  private stateAcronymCode: string;
  private districtCode: string;
  private name: string;
  private population: string;

  public getStateAcronym(): StateAcronym {
    return this.stateAcronym;
  }

  public setStateAcronym(value: StateAcronym): void {
    this.stateAcronym = value;
  }

  public getStateAcronymCode(): string {
    return this.stateAcronymCode;
  }

  public setStateAcronymCode(value: string): void {
    this.stateAcronymCode = value;
  }

  public getDistrictCode(): string {
    return this.districtCode;
  }

  public setDistrictCode(value: string): void {
    this.districtCode = value;
  }

  public getName(): string {
    return this.name;
  }

  public setName(value: string): void {
    this.name = value;
  }

  public getPopulation(): string {
    return this.population;
  }

  public setPopulation(value: string): void {
    this.population = value;
  }
}
